export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      icfPlans: "Plans Multilogements",
      shop: "Boutique",
      sixPlex: "6-Plex",
      eightPlex: "8-Plex",
      twelvePlex: "12-Plex",
      townhomes: "Townhomes",
      investors: "Investisseurs & Prêteurs",
      process: "Du Plan au Permis",
      about: "À Propos",
      team: "Notre Équipe",
      contact: "Contact",
      blog: "Blog"
    },
    hero: {
      headline: "Transformez votre terrain en projet rentable et finançable",
      subheadline: "Plateforme d'analyse et d'optimisation pour développeurs immobiliers. Maximisez la rentabilité de vos projets multiplex.",
      viewPlans: "Voir les modèles",
      downloadGuide: "Optimiser mon projet",
      analyzeFreeCta: "Analyser mon terrain gratuitement",
      optimizeProjectCta: "Optimiser mon projet"
    },
    whyUs: {
      title: "Pourquoi les promoteurs choisissent Plexterra",
      point1Title: "Analyse de rentabilité",
      point1Text: "Optimisez vos projets avec nos outils d'analyse financière avancés.",
      point2Title: "Plans prêts à financer",
      point2Text: "Concepts architecturaux conformes aux exigences SCHL et des prêteurs.",
      point3Title: "Conformité multi-programmes",
      point3Text: "Plans conformes SCHL (Canada) et Fannie Mae/Freddie Mac/FHA (USA).",
      point4Title: "Marchés internationaux",
      point4Text: "Optimisez vos projets au Canada, aux États-Unis et à l'international."
    },
    icf: {
      title: "4 matériaux, 1 objectif : maximiser votre rendement",
      benefit1Title: "ICF - Durabilité maximale",
      benefit1Text: "Structure béton armé 100+ ans, idéal pour investissement long terme.",
      benefit2Title: "Ossature bois - Rapidité",
      benefit2Text: "Construction rapide, coûts maîtrisés, bon ROI court terme.",
      benefit3Title: "Acier léger - Flexibilité",
      benefit3Text: "Grandes portées, adapté aux configurations complexes.",
      benefit4Title: "Hybride - Le meilleur des deux",
      benefit4Text: "Combine résistance du béton et économie du bois.",
      learnMore: "Comparer les matériaux"
    },
    plans: {
      title: "Modèles optimisés pour la rentabilité",
      subtitle: "Concepts architecturaux conçus pour maximiser le rendement et faciliter le financement",
      viewPlan: "Voir le modèle",
      idealFor: "Idéal pour",
      urbanLots: "terrains urbains",
      midSize: "projets intermédiaires",
      largeScale: "projets d'envergure",
      rowHouses: "maisons en rangée"
    },
    esg: {
      title: "Durabilité & Financement : l'avantage ESG",
      text: "Nos plans multiplex sont conçus pour répondre aux exigences croissantes en matière de durabilité. Les caractéristiques ESG facilitent :",
      point1: "L'accès au financement bancaire",
      point2: "Les taux préférentiels pour projets verts",
      point3: "L'admissibilité aux subventions gouvernementales",
      point4: "La valorisation à long terme des actifs",
      viewSheet: "Voir la fiche investisseurs"
    },
    cta: {
      title: "Prêt à maximiser la rentabilité de votre prochain projet?",
      card1Title: "Analyser mon terrain",
      card1Text: "Découvrez le potentiel de votre terrain gratuitement.",
      card1Button: "Analyse gratuite",
      card2Title: "Guide investisseurs",
      card2Text: "Téléchargez notre documentation complète.",
      card2Button: "Télécharger (PDF)",
      card3Title: "Nous contacter",
      card3Text: "Discutons de votre projet d'investissement.",
      card3Button: "Contact"
    },
    icfPage: {
      h1: "Plans multilogements pour investisseurs",
      subtitle: "Concepts architecturaux de calibre institutionnel, optimisés pour la performance financière selon votre stratégie d'investissement.",
      whatIsIcf: "Quel matériau choisir?",
      icfExplanation: "Le choix du matériau dépend de votre horizon d'investissement. ICF pour le long terme (100+ ans), ossature bois pour maximiser le ROI court terme, acier léger pour les configurations complexes, ou hybride pour combiner les avantages.",
      whyInvestorsTitle: "Comment choisir le bon matériau",
      reducedCosts: "Investissement long terme (ICF)",
      reducedCostsPoints: ["Durée de vie 100+ ans", "40-50% économies énergie", "Valeur patrimoniale maximale"],
      riskReduction: "Investissement court terme (Bois)",
      riskReductionPoints: ["Coût de construction réduit de 15-20%", "Construction plus rapide", "ROI initial maximisé"],
      betterFinancing: "Projets complexes (Acier léger)",
      betterFinancingPoints: ["Grandes portées possibles", "Flexibilité architecturale", "Idéal espaces commerciaux"],
      rentalStability: "Équilibre optimal (Hybride)",
      rentalStabilityPoints: ["Structure béton + murs bois", "Bon compromis coût/durabilité", "Polyvalence"],
      comparisonTitle: "Comparaison des matériaux",
      criteria: "Critères",
      woodFrame: "Ossature bois",
      lifespan: "Durée de vie",
      years: "ans",
      insulation: "Isolation (R-value)",
      fireResistance: "Résistance au feu",
      hours: "heures",
      hour: "heure",
      energyCosts: "Coûts énergétiques",
      baseline: "Référence",
      maintenance: "Entretien structurel",
      minimal: "Minimal",
      moderate: "Modéré",
      insurancePremium: "Prime d'assurance",
      soundproofing: "Insonorisation",
      excellent: "Excellente",
      poor: "Faible",
      resaleValue: "Valeur de revente",
      higher: "Supérieure",
      standard: "Standard",
      availableFormats: "Formats disponibles",
      importantNotice: "Avis important",
      noticeText: "Nos plans sont des concepts architecturaux nécessitant une adaptation par un architecte local pour : la conformité au code du bâtiment de votre juridiction, l'adaptation aux caractéristiques de votre terrain, et la certification par un ingénieur agréé. Plexterra n'est pas un entrepreneur général. Nous concevons des plans que vous fournissez aux professionnels de votre choix."
    },
    investors: {
      h1: "Pour Investisseurs & Prêteurs",
      subtitle: "Documentation de calibre bancaire pour une prise de décision éclairée.",
      whyBankable: "Pourquoi ces projets sont finançables",
      icfAdvantages: "Choix du matériau selon votre stratégie",
      icfPoints: ["ICF pour valeur patrimoniale long terme", "Bois pour ROI maximisé court terme", "Hybride pour équilibre optimal"],
      financialPerformance: "Performance financière",
      financialPoints: ["Analyse comparative des matériaux incluse", "Coûts de construction optimisés", "ROI projeté selon le matériau choisi"],
      esgTitle: "ESG & Durabilité",
      esgPoints: ["Options écologiques disponibles", "Conformité SCHL pour financement vert", "Certification énergétique adaptée"],
      rentalTitle: "Stabilité locative",
      rentalPoints: ["Isolation acoustique selon matériau", "Factures utilités réduites", "Construction moderne = positionnement premium"],
      keyMetrics: "Métriques clés",
      downloadPack: "Télécharger le pack investisseur"
    },
    process: {
      h1: "Du Plan au Permis",
      subtitle: "Un processus simplifié pour concrétiser votre projet d'investissement.",
      step1Title: "Analyse & Sélection",
      step1Text: "Analysez votre terrain et choisissez le matériau optimal (ICF, bois, acier, hybride) selon vos objectifs d'investissement.",
      step2Title: "Achat du concept",
      step2Text: "Achetez le pack complet incluant plans architecturaux, documentation technique et guide d'adaptation.",
      step3Title: "Adaptation locale",
      step3Text: "Votre architecte adapte le concept à votre terrain et aux exigences du code du bâtiment local.",
      step4Title: "Certification",
      step4Text: "Un ingénieur agréé certifie les plans structuraux adaptés à votre juridiction.",
      step5Title: "Permis de construction",
      step5Text: "Soumettez les plans certifiés à votre municipalité pour obtenir le permis de construction.",
      step6Title: "Construction",
      step6Text: "Sélectionnez un entrepreneur qualifié dans le matériau choisi et démarrez la construction.",
      whatIncluded: "Ce qui est inclus dans votre achat",
      includedItems: [
        "Plans architecturaux détaillés (PDF + CAD)",
        "Spécifications techniques multi-matériaux",
        "Guide d'adaptation pour architecte",
        "Fiche technique investisseur",
        "Estimations de coûts par matériau",
        "Support par courriel (30 jours)"
      ],
      startProject: "Démarrer votre projet"
    },
    about: {
      h1: "À Propos de Plexterra",
      subtitle: "Votre partenaire de confiance en conception de multilogements.",
      missionTitle: "Notre Mission",
      missionText: "Plexterra se consacre à la conception de plans multilogements de calibre institutionnel. Notre mission est de fournir aux investisseurs immobiliers des concepts architecturaux optimisés pour la performance financière, avec le choix du matériau adapté à leur stratégie.",
      expertiseTitle: "Notre Expertise",
      expertiseText: "Experts en construction multilogement (ICF, ossature bois, acier léger, hybride), nous combinons innovation constructive et rigueur financière pour créer des plans qui répondent aux exigences des investisseurs les plus exigeants.",
      valuesTitle: "Nos Valeurs",
      value1Title: "Excellence",
      value1Text: "Des plans de calibre institutionnel, présentables à tout comité de crédit bancaire.",
      value2Title: "Innovation",
      value2Text: "Analyse comparative des matériaux pour maximiser votre rendement.",
      value3Title: "Transparence",
      value3Text: "Documentation complète et réaliste, sans promesses exagérées.",
      value4Title: "Durabilité",
      value4Text: "Engagement envers les standards ESG et la construction responsable.",
      marketsTitle: "Nos Marchés",
      marketsText: "Nos plans sont conçus pour être adaptables aux marchés canadien, américain et international, avec une attention particulière aux codes du bâtiment et aux exigences de financement de chaque juridiction."
    },
    contact: {
      h1: "Contactez-nous",
      subtitle: "Discutons de votre projet d'investissement multilogement.",
      formTitle: "Envoyez-nous un message",
      name: "Nom complet",
      email: "Courriel",
      phone: "Téléphone (optionnel)",
      company: "Entreprise (optionnel)",
      projectType: "Type de projet",
      selectProject: "Sélectionnez un type de projet",
      project6plex: "6-Plex ICF",
      project8plex: "8-Plex ICF",
      project12plex: "12-Plex ICF",
      projectTownhomes: "Townhomes ICF",
      projectOther: "Autre",
      message: "Message",
      messagePlaceholder: "Décrivez votre projet d'investissement...",
      submit: "Envoyer le message",
      sending: "Envoi en cours...",
      successTitle: "Message envoyé!",
      successText: "Nous vous répondrons dans les 24-48 heures.",
      infoTitle: "Informations",
      responseTime: "Délai de réponse: 24-48 heures",
      languages: "Langues: Français, English",
      markets: "Marchés: Canada, USA, International"
    },
    product: {
      from: "À partir de",
      addToCart: "Commander ce plan",
      features: "Caractéristiques",
      specifications: "Spécifications techniques",
      units: "Unités",
      floors: "Étages",
      sqft: "Superficie",
      fireRating: "Résistance au feu",
      rValue: "Valeur R",
      included: "Ce qui est inclus",
      includedItems: [
        "Plans architecturaux détaillés (PDF + CAD)",
        "Spécifications techniques ICF",
        "Guide d'adaptation pour architecte",
        "Fiche technique investisseur",
        "Support par courriel (30 jours)"
      ],
      disclaimer: "Avis: Ces plans sont des concepts architecturaux nécessitant une adaptation par un architecte agréé local."
    },
    footer: {
      tagline: "Plateforme d'optimisation pour développeurs immobiliers",
      quickLinks: "Liens rapides",
      legal: "Mentions légales",
      legalNotice: "Mention légale",
      privacyPolicy: "Politique de confidentialité",
      termsOfSale: "Conditions de vente",
      newsletter: "Infolettre",
      newsletterText: "Recevez nos analyses et tendances du marché.",
      subscribe: "S'abonner",
      subscribing: "En cours...",
      subscribed: "Abonné!",
      emailPlaceholder: "Votre courriel",
      rights: "Tous droits réservés."
    },
    blog: {
      title: "Blog",
      subtitle: "Articles et guides sur l'investissement immobilier ICF",
      readMore: "Lire la suite",
      backToBlog: "Retour au blog",
      publishedOn: "Publié le",
      category: "Catégorie",
      relatedArticles: "Articles connexes"
    }
  },
  en: {
    nav: {
      home: "Home",
      icfPlans: "Multifamily Plans",
      shop: "Shop",
      sixPlex: "6-Plex",
      eightPlex: "8-Plex",
      twelvePlex: "12-Plex",
      townhomes: "Townhomes",
      investors: "Investors & Lenders",
      process: "From Plan to Permit",
      about: "About",
      team: "Our Team",
      contact: "Contact",
      blog: "Blog"
    },
    hero: {
      headline: "Transform your land into a profitable, financeable project",
      subheadline: "Analysis and optimization platform for real estate developers. Maximize the profitability of your multiplex projects.",
      viewPlans: "View Models",
      downloadGuide: "Optimize my project",
      analyzeFreeCta: "Analyze my land for free",
      optimizeProjectCta: "Optimize my project"
    },
    whyUs: {
      title: "Why Developers Choose Plexterra",
      point1Title: "Profitability Analysis",
      point1Text: "Optimize your projects with our advanced financial analysis tools.",
      point2Title: "Finance-Ready Plans",
      point2Text: "Architectural concepts compliant with CMHC and lender requirements.",
      point3Title: "Multi-Program Compliant",
      point3Text: "Plans compliant with CMHC (Canada) and Fannie Mae/Freddie Mac/FHA (USA).",
      point4Title: "International Markets",
      point4Text: "Optimize your projects in Canada, the United States, and internationally."
    },
    icf: {
      title: "4 Materials, 1 Goal: Maximize Your Returns",
      benefit1Title: "ICF - Maximum Durability",
      benefit1Text: "100+ year reinforced concrete structure, ideal for long-term investment.",
      benefit2Title: "Wood Frame - Speed",
      benefit2Text: "Fast construction, controlled costs, good short-term ROI.",
      benefit3Title: "Light Steel - Flexibility",
      benefit3Text: "Wide spans, suited for complex configurations.",
      benefit4Title: "Hybrid - Best of Both",
      benefit4Text: "Combines concrete strength with wood economy.",
      learnMore: "Compare Materials"
    },
    plans: {
      title: "Models Optimized for Profitability",
      subtitle: "Architectural concepts designed to maximize returns and facilitate financing",
      viewPlan: "View Model",
      idealFor: "Ideal for",
      urbanLots: "urban lots",
      midSize: "mid-size projects",
      largeScale: "large-scale projects",
      rowHouses: "row houses"
    },
    esg: {
      title: "Sustainability & Financing: The ESG Advantage",
      text: "Our multiplex plans are designed to meet growing sustainability requirements. ESG characteristics facilitate:",
      point1: "Access to bank financing",
      point2: "Preferential rates for green projects",
      point3: "Eligibility for government subsidies",
      point4: "Long-term asset appreciation",
      viewSheet: "View Investor Sheet"
    },
    cta: {
      title: "Ready to maximize your next project's profitability?",
      card1Title: "Analyze my land",
      card1Text: "Discover your land's potential for free.",
      card1Button: "Free Analysis",
      card2Title: "Investor Guide",
      card2Text: "Download our complete documentation.",
      card2Button: "Download (PDF)",
      card3Title: "Contact Us",
      card3Text: "Let's discuss your investment project.",
      card3Button: "Contact"
    },
    icfPage: {
      h1: "ICF Multifamily Plans for Investors",
      subtitle: "Institutional-grade architectural concepts optimized for financial performance and sustainability.",
      whatIsIcf: "What is ICF?",
      icfExplanation: "Insulated Concrete Forms (ICF) are a construction system where expanded polystyrene blocks serve as permanent formwork for reinforced concrete. This technology offers exceptional thermal insulation and unmatched durability.",
      whyInvestorsTitle: "Why Investors Choose ICF",
      reducedCosts: "Reduced Operating Costs",
      reducedCostsPoints: ["40-50% savings on heating/cooling", "Less structural maintenance", "100+ year lifespan"],
      riskReduction: "Risk Reduction",
      riskReductionPoints: ["4-hour fire resistance (vs 1 hour for wood)", "Extreme weather resistance", "Insurance premiums reduced up to 25%"],
      betterFinancing: "Better Financing",
      betterFinancingPoints: ["ESG compliance sought by lenders", "Eligibility for green programs", "Higher resale value"],
      rentalStability: "Rental Stability",
      rentalStabilityPoints: ["Superior acoustic comfort (tenant retention)", "Reduced energy bills (attractiveness)", "Modern, sustainable image"],
      comparisonTitle: "ICF vs Wood Frame Comparison",
      criteria: "Criteria",
      woodFrame: "Wood Frame",
      lifespan: "Lifespan",
      years: "years",
      insulation: "Insulation (R-value)",
      fireResistance: "Fire Resistance",
      hours: "hours",
      hour: "hour",
      energyCosts: "Energy Costs",
      baseline: "Baseline",
      maintenance: "Structural Maintenance",
      minimal: "Minimal",
      moderate: "Moderate",
      insurancePremium: "Insurance Premium",
      soundproofing: "Soundproofing",
      excellent: "Excellent",
      poor: "Poor",
      resaleValue: "Resale Value",
      higher: "Higher",
      standard: "Standard",
      availableFormats: "Available Formats",
      importantNotice: "Important Notice",
      noticeText: "Our plans are architectural concepts requiring adaptation by a local architect for: compliance with your jurisdiction's building code, adaptation to your land characteristics, and certification by a licensed engineer. Plexterra is not a general contractor. We design plans that you provide to the professionals of your choice."
    },
    investors: {
      h1: "For Investors & Lenders",
      subtitle: "Bank-grade documentation for confident decision-making.",
      whyBankable: "Why These Projects Are Bankable",
      icfAdvantages: "ICF Structural Advantages",
      icfPoints: ["100+ year durability reduces long-term risk", "Fire and weather resistance minimizes claims", "Lower insurance premiums improve NOI"],
      financialPerformance: "Financial Performance",
      financialPoints: ["40-50% energy savings increase net operating income", "Lower maintenance costs over building lifecycle", "Higher tenant retention due to comfort"],
      esgTitle: "ESG & Sustainability",
      esgPoints: ["Reduced carbon footprint aligns with ESG mandates", "CMHC compliance meets green financing criteria", "Future-proof against tightening energy regulations"],
      rentalTitle: "Rental Stability",
      rentalPoints: ["Superior acoustic insulation = happier tenants", "Lower utility costs = competitive rents", "Modern construction = premium positioning"],
      keyMetrics: "Key Metrics",
      downloadPack: "Download Investor Pack"
    },
    process: {
      h1: "From Plan to Permit",
      subtitle: "A simplified process to bring your investment project to life.",
      step1Title: "Plan Selection",
      step1Text: "Choose from our ICF 6-plex, 8-plex, 12-plex or townhomes concepts based on your investment goals.",
      step2Title: "Concept Purchase",
      step2Text: "Purchase the complete pack including architectural plans, technical documentation and adaptation guide.",
      step3Title: "Local Adaptation",
      step3Text: "Your architect adapts the concept to your land and local building code requirements.",
      step4Title: "Certification",
      step4Text: "A licensed engineer certifies the structural plans adapted to your jurisdiction.",
      step5Title: "Building Permit",
      step5Text: "Submit the certified plans to your municipality to obtain the building permit.",
      step6Title: "Construction",
      step6Text: "Select a qualified ICF contractor and start construction of your project.",
      whatIncluded: "What's Included in Your Purchase",
      includedItems: [
        "Detailed architectural plans (PDF + CAD)",
        "ICF technical specifications",
        "Adaptation guide for architect",
        "Investor fact sheet",
        "Indicative cost estimates",
        "Email support (30 days)"
      ],
      startProject: "Start Your Project"
    },
    about: {
      h1: "About Plexterra",
      subtitle: "Your trusted partner in ICF multifamily design.",
      missionTitle: "Our Mission",
      missionText: "Plexterra is dedicated to designing institutional-grade ICF multifamily plans. Our mission is to provide real estate investors with architectural concepts optimized for financial performance and environmental sustainability.",
      expertiseTitle: "Our Expertise",
      expertiseText: "Specializing in insulated concrete forms (ICF), we combine construction innovation and financial rigor to create plans that meet the requirements of the most demanding investors and lenders.",
      valuesTitle: "Our Values",
      value1Title: "Excellence",
      value1Text: "Institutional-grade plans, presentable to any bank credit committee.",
      value2Title: "Innovation",
      value2Text: "Cutting-edge ICF technology for maximum durability and efficiency.",
      value3Title: "Transparency",
      value3Text: "Complete and realistic documentation, without exaggerated promises.",
      value4Title: "Sustainability",
      value4Text: "Commitment to ESG standards and responsible construction.",
      marketsTitle: "Our Markets",
      marketsText: "Our plans are designed to be adaptable to Canadian, American and international markets, with particular attention to building codes and financing requirements of each jurisdiction."
    },
    contact: {
      h1: "Contact Us",
      subtitle: "Let's discuss your multifamily investment project.",
      formTitle: "Send Us a Message",
      name: "Full Name",
      email: "Email",
      phone: "Phone (optional)",
      company: "Company (optional)",
      projectType: "Project Type",
      selectProject: "Select a project type",
      project6plex: "6-Plex ICF",
      project8plex: "8-Plex ICF",
      project12plex: "12-Plex ICF",
      projectTownhomes: "ICF Townhomes",
      projectOther: "Other",
      message: "Message",
      messagePlaceholder: "Describe your investment project...",
      submit: "Send Message",
      sending: "Sending...",
      successTitle: "Message Sent!",
      successText: "We will respond within 24-48 hours.",
      infoTitle: "Information",
      responseTime: "Response time: 24-48 hours",
      languages: "Languages: Français, English",
      markets: "Markets: Canada, USA, International"
    },
    product: {
      from: "Starting at",
      addToCart: "Order This Plan",
      features: "Features",
      specifications: "Technical Specifications",
      units: "Units",
      floors: "Floors",
      sqft: "Square Footage",
      fireRating: "Fire Rating",
      rValue: "R-Value",
      included: "What's Included",
      includedItems: [
        "Detailed architectural plans (PDF + CAD)",
        "ICF technical specifications",
        "Adaptation guide for architect",
        "Investor fact sheet",
        "Email support (30 days)"
      ],
      disclaimer: "Notice: These plans are architectural concepts requiring adaptation by a licensed local architect."
    },
    footer: {
      tagline: "Optimization platform for real estate developers",
      quickLinks: "Quick Links",
      legal: "Legal",
      legalNotice: "Legal Notice",
      privacyPolicy: "Privacy Policy",
      termsOfSale: "Terms of Sale",
      newsletter: "Newsletter",
      newsletterText: "Receive our market analysis and trends.",
      subscribe: "Subscribe",
      subscribing: "Subscribing...",
      subscribed: "Subscribed!",
      emailPlaceholder: "Your email",
      rights: "All rights reserved."
    },
    blog: {
      title: "Blog",
      subtitle: "Articles and guides on ICF real estate investment",
      readMore: "Read more",
      backToBlog: "Back to blog",
      publishedOn: "Published on",
      category: "Category",
      relatedArticles: "Related articles"
    }
  }
};
